import styled from 'styled-components';
import { token } from '@atlaskit/tokens';

type WithFontSize = {
  fontSize?: string;
};

const CellSubLine = styled.div<{ fontSize: string }>`
  color: ${token('color.text', '#172B4D')};
  font-size: ${(props: WithFontSize) => props.fontSize || '12px'};
  font-weight: 400;
  position: relative;
  top: -4px;
`;

export default CellSubLine;
